var PW = {};

PW.raffleSubmitCount = 0; // For Raffle Form

jQuery(document).ready(function($){
